export default {
  CONFIDENCE_LEVELS: 'Confidence Levels',
  CONFIDENCE_LEVELS_DESCRIPTION:
    'View and manage confidence levels used to calculate the projected value of Opportunities.',
  CONFIDENCE_LEVEL_NAME_LABEL: 'Level Name',
  CONFIDENCE_LEVEL_PERCENTAGE_LABEL: 'Level Percentage',
  CONFIDENCE_LEVEL_ADD_LEVEL: 'Add Level',
  CONFIDENCE_LEVEL_REMOVE_LEVEL: 'Remove Level',
  CONFIDENCE_LEVEL_EDIT_LEVEL: 'Edit Level',
  CONFIDENCE_LEVEL_DELETE_CONFIRM_MSG:
    'Are you sure you want to delete this level?',
  CONFIDENCE_LEVEL_CREATE_SUCCESS: 'Confidence level successfully created',
  CONFIDENCE_LEVEL_CREATE_FAILURE: 'Error, confidence level creation failed',
  CONFIDENCE_LEVEL_UPDATE_SUCCESS: 'Confidence level successfully updated',
  CONFIDENCE_LEVEL_UPDATE_FAILURE: 'Error, confidence level update failed',
  CONFIDENCE_LEVEL_DELETE_SUCCESS: 'Confidence level successfully deleted',
  CONFIDENCE_LEVEL_DELETE_FAILURE: 'Error, confidence level deletion failed',
  CONFIDENCE_LEVEL_CAN_NOT_DELETE:
    'There {count, plural, =1 {is 1 opportunity} other {are # opportunities}} associated with this level. Update their status first then return to delete this level.',
  CONFIDENCE_LEVEL_AMOUNT_MINIMUM_ERROR: 'Minimum value of 0',
  CONFIDENCE_LEVEL_AMOUNT_MAXIMUM_ERROR: 'Maximum value of 100',
};
